<template>
  <div class="apply-collection">
    <div class="apply-bg" v-if="!applySubmit">
      <img v-if="stepIndex == 0" src="../../assets/images/apply-bg.png" alt="">
      <div v-if="stepIndex > 0" class="apply-header">
        <div class="steps">
          <div class="step-line"></div>
          <div class="step flex1">
            <div class="step-index" :class="stepIndex ==1 ? 'icon-light' : 'icon-gray'">1</div>
            <div class="step-title" :class="stepIndex ==1 ? 'white-color' : 'color-gray'">填写基本信息</div>
          </div>
          <div class="step flex1">
            <div class="step-index" :class="stepIndex ==2 ? 'icon-light' : 'icon-gray'">2</div>
            <div class="step-title" :class="stepIndex ==2 ? 'white-color' : 'color-gray'">填写商户信息</div>
          </div>
          <div class="step flex1">
            <div class="step-index" :class="stepIndex ==3 ? 'icon-light' : 'icon-gray'">3</div>
            <div class="step-title" :class="stepIndex ==3 ? 'white-color' : 'color-gray'">填写结算账户</div>
          </div>
        </div>
      </div>
      <div class="step-content">
        <div class="step-one" v-if="stepIndex == 1">
          <van-row class="step-row">
            <van-row class="row-title">
              <img style="width:0.25rem;" src="../../assets/images/row-title.png" alt="">
              <span>超级管理员</span>
              <img style="width:0.25rem;" src="../../assets/images/row-title.png" alt="">
            </van-row>
            <van-row class="row-content">
              <van-row class="input-title">超管姓名<span style="color:#FF5C32">*</span></van-row>
              <van-row class="input-content">
                <input type="text" v-model="contactorInfo.contact" maxlength="20">
              </van-row>
              <van-row class="input-explain fs12">超级管理员就是法人，将接收开户信息及完成签约，并可进行商户号的日常重要管理及资金操作</van-row>
            </van-row>
            <van-row class="row-content">
              <van-row class="input-title">手机号码<span style="color:#FF5C32">*</span></van-row>
              <van-row class="input-content">
                <input type="number" v-model="contactorInfo.contactPhone"  oninput="if(value.length>11)value=value.slice(0,11)">
              </van-row>
              <van-row class="input-explain fs12">用于接收微信支付的重要管理信息及日常操作验证码，超管签约时可自助修改手机号，并进行短信验证</van-row>
            </van-row>
            <van-row class="row-content">
              <van-row class="input-title">证件号码<span style="color:#FF5C32">*</span></van-row>
              <van-row class="input-content">
                <input type="text" v-model="contactorInfo.contactIdNumber">
              </van-row>
              <van-row class="input-explain fs12">请填写超级管理员的证件号码，可传身份证、来往内地通行证、来往大陆通行证、护照等证件号码</van-row>
            </van-row>
            <van-row class="row-content">
              <van-row class="input-title">常用邮箱<span style="color:#FF5C32">*</span></van-row>
              <van-row class="input-content">
                <input type="text" v-model="contactorInfo.contactEmail" maxlength="30">
              </van-row>
              <van-row class="input-explain fs12">非常重要！用于接收微信支付的开户邮件及日常业务通知</van-row>
            </van-row>
          </van-row>
          <van-row class="step-row mt12">
            <van-row class="row-title">
              <img style="width:0.25rem;" src="../../assets/images/row-title.png" alt="">
              <span>经营信息</span>
              <img style="width:0.25rem;" src="../../assets/images/row-title.png" alt="">
            </van-row>
            <van-row class="row-content">
              <van-row class="input-title">商户简称<span style="color:#FF5C32">*</span></van-row>
              <van-row class="input-content">
                <input type="text" v-model="manageInfo.mchShortname" maxlength="50">
              </van-row>
              <van-row class="input-explain fs12">该简称将在支付完成页向买家展示，需与微信经营类目相关</van-row>
            </van-row>
            <van-row class="row-content">
              <van-row class="input-title">经营类目<span style="color:#FF5C32">*</span></van-row>
              <van-row class="input-content">
                <textarea rows="2" disabled v-model="manageInfo.manageType" maxlength="100"></textarea>
              </van-row>
              <van-row class="input-explain fs12">选择的类目为实物类；结算周期为<font class="red-color">T+1</font> ；入账方式为<font class="red-color">即时入账至商户号</font> ；手续需要缴纳的手续费将从每笔交易中抽取。</van-row>
            </van-row>
            <van-row class="row-content">
              <van-row class="input-title">公众号名称<span style="color:#FF5C32">*</span></van-row>
              <van-row class="input-content">
                <input type="text" v-model="manageInfo.publicName" maxlength="50">
              </van-row>
              <van-row class="input-explain fs12">公众号必须有内容，能清晰介绍公众号业务及支付功能使用场景</van-row>
            </van-row>
            <van-row class="row-content">
              <van-row class="input-title">售卖商品/提供服务概述<span style="color:#FF5C32">*</span></van-row>
              <van-row class="input-content">
                <textarea rows="4" v-model="manageInfo.productDesc" maxlength="300"></textarea>
              </van-row>
              <van-row class="input-explain fs12">请简述售卖的商品或提供的服务，必须在营业执照经营范围内，且与所选类目一致，请勿直接照抄营业执照中的经营范围，否则将导致申请被驳回</van-row>
            </van-row>
            <van-row class="row-content">
              <van-row class="input-title">客服电话<span style="color:#FF5C32">*</span></van-row>
              <van-row class="input-content">
                <input type="text" v-model="manageInfo.servicePhone" maxlength="50">
              </van-row>
              <van-row class="input-explain fs12">请正确填写客服电话，座机务必填写区号，格式如（座机：0755-XXXXXXXX；手机：136XXXXXXXX；400电话：400XXXXXXX）</van-row>
            </van-row>
          </van-row>
        </div>
        <div class="step-two" v-else-if="stepIndex == 2">
          <van-row class="step-row">
            <van-row class="row-title">
              <img style="width:0.25rem;" src="../../assets/images/row-title.png" alt="">
              <span>营业执照</span>
              <img style="width:0.25rem;" src="../../assets/images/row-title.png" alt="">
            </van-row>
            <van-row class="row-content">
              <van-row class="input-title">营业执照照片<span style="color:#FF5C32">*</span></van-row>
              <van-row class="upload-row">
                <van-col span="8" v-if="!businessLicense">
                  <van-uploader :after-read="onRead" accept="image/*" @click.native="uploadFlag='businessLicense'" class="business-license" >
                    <div class="pluss" >
                      <span class="iconfont icontianjiafujian" style="margin-top: 0.2rem;font-size:0.2rem;"></span>
                      <span class="fs16">添加图片</span>
                    </div>
                  </van-uploader>
                </van-col>
                <van-col v-else class="uploadImgCol" span="8">
                  <img class="uploadImg" :src="businessLicense" @click="preImgClick(businessLicense)">
                  <div class="imgDeleteBtn" @click="deleteImg('businessLicense')">
                    <van-icon name="delete" />
                  </div>
                </van-col>
                <van-col span="16" class="placeholder-color fs12">
                  ① 需年检章齐全（当年成立公司除外）; <br>②必须为彩色图片且小于2M，文件格式为bmp、png、jpeg、jpg或gif
                </van-col>
              </van-row>
            </van-row>
            <van-row class="row-content">
              <van-row class="input-title">营业期限<span style="color:#FF5C32">*</span><van-checkbox class="businessLongTime" v-model="businessLongTime" shape="square">长期</van-checkbox></van-row>
              <van-row class="dateRange-row">
                <van-col span="11" @click.native="selectBusinessTimeBegin = true"><input  type="text" disabled v-model="businessInfo.bussBeginDate"></van-col>
                <van-col span="1" style="line-height:0.4rem;text-align:center;">至</van-col>
                <van-col span="11" @click.native="selectBusinessTimeEnd = true" offset="1"><input type="text" disabled v-model="businessInfo.bussEndDate"></van-col>
              </van-row>
              <!-- <van-row class="input-content" @click.native="selectBusinessTime=true">
                <input type="text" v-model="businessInfo.businessTime" disabled >
              </van-row> -->
              <van-row class="input-explain fs12">证件有效期限需与上传文件上所示期限一致，若有效期超过2100年，请选择“长期”</van-row>
            </van-row>
            <van-row class="row-content">
              <van-row class="input-title">营业执照注册号<span style="color:#FF5C32">*</span></van-row>
              <van-row class="input-content">
                <input type="text" v-model="businessInfo.bussLicenseNum" maxlength="18">
              </van-row>
              <van-row class="input-explain fs12">您输入的是18位统一社会信用代码，无需再提交组织机构代码证</van-row>
            </van-row>
            <van-row class="row-content">
              <van-row class="input-title">经营范围<span style="color:#FF5C32">*</span></van-row>
              <van-row class="input-content">
                <textarea rows="4" v-model="businessInfo.businessScope" maxlength="300"></textarea>
              </van-row>
              <van-row class="input-explain fs12">与企业工商营业执照上一致</van-row>
            </van-row>
          </van-row>
          <van-row class="step-row mt12">
            <van-row class="row-title">
              <img style="width:0.25rem;" src="../../assets/images/row-title.png" alt="">
              <span>基本信息</span>
              <img style="width:0.25rem;" src="../../assets/images/row-title.png" alt="">
            </van-row>
            <van-row class="row-content">
              <van-row class="input-title">商户名称<span style="color:#FF5C32">*</span></van-row>
              <van-row class="input-content">
                <input type="text" v-model="merchantName" maxlength="50">
              </van-row>
              <van-row class="input-explain fs12">商户名称需与营业执照登记公司名称一致</van-row>
            </van-row>
            <van-row class="row-content">
              <van-row class="input-title">注册地址<span style="color:#FF5C32">*</span></van-row>
              <van-row class="input-content">
                <textarea rows="4" v-model="companyAddress" maxlength="100"></textarea>
              </van-row>
              <van-row class="input-explain fs12">注册地址需与营业执照登记住所一致</van-row>
            </van-row>
          </van-row>
          <van-row class="step-row mt12">
            <van-row class="row-title">
              <img style="width:0.25rem;" src="../../assets/images/row-title.png" alt="">
              <span>企业法人</span>
              <img style="width:0.25rem;" src="../../assets/images/row-title.png" alt="">
            </van-row>
            <van-row class="row-content">
              <van-row class="input-title">企业法人<span style="color:#FF5C32">*</span></van-row>
              <van-row class="upload-row">
                <van-col span="12" v-if="!idCardFront">
                  <van-uploader :after-read="onRead" accept="image/*" @click.native="uploadFlag='idCardFront'" class="id-card" >
                    <div class="pluss-idcard" >
                      <span class="iconfont icontianjiafujian" style="margin-top: 0.3rem;font-size:0.2rem;"></span>
                      <span class="fs16">身份证正面照片</span>
                    </div>
                  </van-uploader>
                </van-col>
                <van-col v-else class="uploadImgCol" span="12">
                  <img class="uploadImg-idcard" :src="idCardFront" @click="preImgClick(idCardFront)">
                  <div class="imgDeleteBtn-idcard" @click="deleteImg('idCardFront')">
                    <van-icon name="delete" />
                  </div>
                </van-col>
                <van-col span="12" v-if="!idCardBehind">
                  <van-uploader :after-read="onRead" accept="image/*" @click.native="uploadFlag='idCardBehind'" class="id-card" >
                    <div class="pluss-idcard" >
                      <span class="iconfont icontianjiafujian" style="margin-top: 0.3rem;font-size:0.2rem;"></span>
                      <span class="fs16">身份证反面照片</span>
                    </div>
                  </van-uploader>
                </van-col>
                <van-col v-else class="uploadImgCol" span="12">
                  <img class="uploadImg-idcard" :src="idCardBehind" @click="preImgClick(idCardBehind)">
                  <div class="imgDeleteBtn-idcard" @click="deleteImg('idCardBehind')">
                    <van-icon name="delete" />
                  </div>
                </van-col>
              </van-row>
              <van-row class="input-explain fs12">必须为彩色图片且小于2M，文件格式为bmp、png、jpeg、jpg或gif</van-row>
            </van-row>
            <van-row class="row-content">
              <van-row class="input-title">身份证号码<span style="color:#FF5C32">*</span></van-row>
              <van-row class="input-content">
                <input type="text" v-model="legalPerson.idCardNumber" maxlength="20">
              </van-row>
            </van-row>
            <van-row class="row-content">
              <van-row class="input-title">身份证姓名<span style="color:#FF5C32">*</span></van-row>
              <van-row class="input-content">
                <input type="text" v-model="legalPerson.idCardName" maxlength="20">
              </van-row>
            </van-row>
            <van-row class="row-content">
              <van-row class="input-title">证件有效期<span style="color:#FF5C32">*</span><van-checkbox class="businessLongTime" v-model="idCardLongTime" shape="square">长期</van-checkbox></van-row>
              <van-row class="dateRange-row">
                <van-col span="11" @click.native="selectBeginDate = true"><input  type="text" disabled v-model="legalPerson.validityBegin"></van-col>
                <van-col span="1" style="line-height:0.4rem;text-align:center;">至</van-col>
                <van-col span="11" @click.native="selectEndDate = true" offset="1"><input type="text" disabled v-model="legalPerson.validityEnd"></van-col>
              </van-row>
              <van-row class="input-explain fs12">证件有效期限需与上传文件上所示期限一致，若有效期超过2100年，请选择“长期”</van-row>
            </van-row>
            <van-row class="row-content">
              <van-row class="input-title">身份证地址<span style="color:#FF5C32">*</span></van-row>
              <van-row class="input-content">
                <input type="text" v-model="legalPerson.idCardAddress" >
              </van-row>
              <van-row class="input-explain fs12">请按照身份证住址填写，如广东省深圳市南山区xx路xx号xx室</van-row>
            </van-row>
          </van-row>
        </div>
        <div class="step-two" v-else-if="stepIndex == 3">
          <van-row class="step-row">
            <van-row class="row-title">
              <img style="width:0.25rem;" src="../../assets/images/row-title.png" alt="">
              <span>结账账户</span>
              <img style="width:0.25rem;" src="../../assets/images/row-title.png" alt="">
            </van-row>
            <van-row class="row-content">
              <van-row class="input-title" style="line-height:0.3rem;">账户类型：<span >对公账户</span></van-row>
              <van-row class="input-title" style="line-height:0.3rem;">开户名称：<span >{{merchantName}}</span></van-row>
            </van-row>
            <van-row class="row-content">
              <van-row class="input-title">基本户开户行 <span style="color:#FF5C32">*</span></van-row>
              <van-row class="input-content">
                <div class="basic-banks" @click="selectBanks = true">{{baseBank.bankName}}</div>
                <i class="corner"></i>
                <!-- <van-col span="21"></van-col>
                <van-col span="3"></van-col> -->
              </van-row>
              <van-row class="input-explain fs12">城市商业银行、农村商业银行、信用合作联社及其他银行,请选择“其他银行”</van-row>
            </van-row>
            <van-row class="row-content">
              <van-row class="input-title">基本户开户支行 <span style="color:#FF5C32">*</span></van-row>
              <van-row class="input-content">
                <van-row>
                  <van-col span="24">
                    <div class="area-province" @click="selectBanksArea = true"><span v-if="!subBankArea" style="color:#b4bec7;">请选择开户支行的省市</span><span v-else>{{subBankArea}}</span></div>
                    <i class="corner"></i>
                  </van-col>
                </van-row>
                <van-row>
                  <input type="text" id="subBank" v-model="subBankName" @focus="subBankFocus" @blur="endEdit" maxlength="50" autocomplete="off">
                  <ul class="subbank-list" v-show="subBanks.length > 0 && subBankEdit">
                    <li class="sub-bank" v-for="subBank in subBanks" :key="subBank.bankCode" @click="selectSubBank(subBank)">{{subBank.bankName}}</li>
                  </ul>
                </van-row>
                <!-- <textarea rows="4"></textarea> -->
              </van-row>
              <van-row class="input-explain fs12">与企业工商营业执照上一致</van-row>
            </van-row>
            <van-row class="row-content">
              <van-row class="input-title">基本户银行账号<span style="color:#FF5C32">*</span></van-row>
              <van-row class="input-content">
                <input type="number" v-model="bankNo" maxlength="20">
              </van-row>
            </van-row>
          </van-row>
        </div>
      </div>
    </div>
    <div class="apply-submit" v-if="applySubmit">
      <van-row class="submit-img">
        <img src="../../assets/images/apply-submit.png" alt="">
      </van-row>
      <van-row style="margin-top:0.28rem;">
        <van-row class="text-center" style="color:#3C4C5D;">{{$store.state.acctCompanyInfo.name}}</van-row>
        <van-row v-if="applyStatus == 0" class="fs18 text-center red-color" style="line-height:0.4rem;">您的微信收款开户申请已提交</van-row>
        <van-row v-if="applyStatus == 1" class="fs18 text-center red-color" style="line-height:0.4rem;">您的微信收款开户成功</van-row>
      </van-row>
      <van-row v-if="!from" class="rate-row text-center"><span @click="toApplyRate()">查看开户进度&nbsp;></span></van-row>
    </div>
    <div class="footer" v-if="!applySubmit">
      <!-- <div v-if="stepIndex == 0" class="rate-btn title-color flex1" @click="rateView()">查看进度</div> -->
      <div v-if="stepIndex == 0" class="apply-btn flex1 white-color color-confirm" @click="toApply()">现在去开户</div>
      <div v-if="stepIndex > 1" class="last-step title-color flex1" @click="lastStep">上一步</div>
      <div v-if="stepIndex > 0 && stepIndex < 3" class="next-step flex2 white-color color-confirm" @click="nextStep">下一步</div>
      <div v-if="stepIndex == 3" class="next-step flex2 white-color color-confirm" @click="submitConfirm">提交</div>
    </div>
    <van-popup v-model="selectBusinessTimeBegin" position="bottom">
      <van-datetime-picker v-model="bussBeginDate" type="date" @confirm="confirmBussBeginDate" @cancel="selectBusinessTimeBegin = false" :min-date="minDate" :max-date="maxDate" />
    </van-popup>
    <van-popup v-model="selectBusinessTimeEnd" position="bottom">
      <van-datetime-picker v-model="bussEndDate" type="date" @confirm="confirmBussEndDate" @cancel="selectBusinessTimeBegin = false" :min-date="minDate" :max-date="maxDate" />
    </van-popup>
    <!-- 身份证有效期 -->
    <van-popup v-model="selectBeginDate" position="bottom">
      <van-datetime-picker v-model="beginDate" type="date" :min-date="minDate" :max-date="maxDate" @confirm="confirmBeginDate" @cancel="selectBeginDate = false" />
    </van-popup>
    <van-popup v-model="selectEndDate" position="bottom">
      <van-datetime-picker v-model="endDate" type="date" :min-date="minDate" :max-date="maxDate"  @confirm="confirmEndDate" @cancel="selectEndDate = false"/>
    </van-popup>
    <!-- 基本开户行 -->
    <van-popup v-model="selectBanks" position="bottom">
      <van-picker show-toolbar title="基本开户行" :columns="banks" @cancel="selectBanks=false" @confirm="confirmBank"/>
    </van-popup>
    <!-- 支行地区 -->
    <van-popup v-model="selectBanksArea" position="bottom">
      <van-area :area-list="areaList" :columns-num="2" title="地区" @confirm="confirmArea" @cancel="selectBanksArea=false" />
    </van-popup>
  </div>
</template>

<script>
import Vue from 'vue'
import Exif from 'exif-js';
import axios from "axios";
import areaList from '../../common/lib/area'
// import moment from "moment";
import {Row, Col, Toast, Uploader, Icon, ImagePreview, DatetimePicker, Popup, Area, Picker, Checkbox } from "vant";
Vue.use(Row).use(Col).use(Uploader).use(Icon).use(ImagePreview).use(DatetimePicker).use(Popup).use(Area).use(Picker).use(Checkbox);
export default {
  name: 'applyCollection',
  data(){
    return {
      areaList: {},
      contactorInfo: {},
      manageInfo:{manageType: '企业 > 居民生活/商业服务 > 咨询/法律咨询/金融咨询等'},
      businessInfo: {},
      legalPerson: {},
      merchantName: '',
      companyAddress: '',
      applySubmit: false,
      stepIndex: 2,
      uploadFlag:'',
      idCardFront: '',
      idCardFrontMediaId:'',
      idCardBehind: '',
      idCardBehindMediaId:'',
      businessLicense: '',
      businessMediaId:'',
      files: {
        name: "",
        type: ""
      },
      businessLongTime: false,
      idCardLongTime: false,
      selectBusinessTimeBegin: false,
      selectBusinessTimeEnd: false,
      selectBusinessTime: false,
      imagePreview: null,
      bussBeginDate: new Date(),
      bussEndDate: new Date(),
      selectBeginDate: false,
      selectEndDate: false,
      beginDate: new Date(),
      endDate: new Date(),
      selectBanks: false,
      banks:[],
      baseBank: {},
      subBankName: '',
      subBank: {},
      selectBanksArea: false,
      bankArea: [],
      cancel: null,
      subBanks: [],
      subBankEdit: false,
      bankNo: '',
      applyStatus: 0,
      applyId: null,
      eid: '',
      from: '',
      companyName: '',
      maxDate: new Date('2100/12/31'),
      minDate: new Date('1970/01/01'),
      submiting: false,
      tempSubBankName: '',
      tempSubBankCode: '',
      uploadToast:{}
    }
  },
  beforeRouteLeave (to, from, next) {
    if (!this.applyId) {
      window.sessionStorage.setItem('page', JSON.stringify(this.$data))
    }
    next()
  },
  watch: {
    subBankName(newval){
      this.subBank.bankName = newval;
      this.debounce(this.getSubBank, 666);
    }
  },
  computed: {
    subBankArea(){
      if (this.bankArea.length > 0) {
        return (this.bankArea[0] ? this.bankArea[0].name : '') + (this.bankArea[1] ? this.bankArea[1].name : '')
      }
      return ''
    }
  },
  create(){
  },
  mounted() {
    if (this.$route.params.hasOwnProperty('stepIndex')) {
      this.stepIndex = this.$route.params.stepIndex
      this.getDetailInfo()
    }
    if (this.$route.query.eid && this.$route.query.from) {
      this.eid = this.$route.query.eid
      this.from = this.$route.query.from
      let status = this.$route.query.applyStatus
      this.companyName = this.$route.query.companyName
      if (status == 3) {
        this.stepIndex = 1
        this.getDetailInfo()
      }
    }

    let page = JSON.parse(window.sessionStorage.getItem('page'))
    if (page && !page.applyId) {
      for (const key in page) {
        if (this.$data.hasOwnProperty(key)) {
          this.$data[key] = page[key]
          if (key === 'beginDate' || key === 'endDate') {
            let dt = page[key] && page[key].replace(/-/g,'/');
            this.$data[key] = new Date(dt);
          }
        }
      }
    }
    this.areaList = areaList
    this.getBaseBanks()
  },
  methods: {
    //防抖函数
    debounce(fn, wait) {
      if (this.timer !== null) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(fn, wait);
    },
    getDetailInfo(){
      let eid = window.sessionStorage.getItem('eid')
      if (this.eid) {
        eid = this.eid
      }
      this.$http.get('/ommall/wechat/serviceprovider/applyinfo?eid='+eid).then(res=>{
        if (res.data.code == 200) {
          let data = res.data.data
          if (data) {
            this.applyId = data.id
            let contactorInfo = {}
            contactorInfo.contact = data.contact
            contactorInfo.contactPhone = data.contactPhone
            contactorInfo.contactIdNumber = data.contactIdNumber
            contactorInfo.contactEmail = data.contactEmail
            this.contactorInfo = contactorInfo
            let manageInfo = {}
            manageInfo.mchShortname = data.mchShortname
            manageInfo.manageType = data.manageType
            manageInfo.publicName = data.publicName
            manageInfo.productDesc = data.productDesc
            manageInfo.servicePhone = data.servicePhone
            this.manageInfo = manageInfo
            let businessInfo = {}
            let businessTime = JSON.parse(data.businessTime)
            businessInfo.bussBeginDate = businessTime[0] 
            if (businessTime[1] === '长期') {
              this.businessLongTime = true
            } else {
              businessInfo.bussEndDate = businessTime[1]
            }
            businessInfo.businessScope = data.businessScope
            this.businessLicense = data.bussLicenseCopyUrl
            this.businessMediaId = data.bussLicenseCopy
            businessInfo.bussLicenseNum = data.bussLicenseNum
            this.businessInfo = businessInfo
            this.merchantName = data.merchantName
            this.companyAddress = data.companyAddress

            let legalPerson = {}
            this.idCardFront = data.idCardCopyUrl
            this.idCardFrontMediaId = data.idCardCopy
            this.idCardBehind = data.idCardNationalUrl
            this.idCardBehindMediaId = data.idCardNational
            legalPerson.idCardNumber = data.idCardNumber
            legalPerson.idCardName = data.idCardName
            legalPerson.idCardAddress = data.idCardAddress
            let idCardValidTime = JSON.parse(data.idCardValidTime)
            legalPerson.validityBegin = idCardValidTime[0]
            if (idCardValidTime[1] === '长期') {
              this.idCardLongTime = true
            } else {
              legalPerson.validityEnd = idCardValidTime[1]
            }
            this.legalPerson = legalPerson
            let baseBank = {}
            baseBank.bankName = data.accountBank
            baseBank.bankNo = data.accountBankCode
            this.baseBank = baseBank
            let bankArrCode = data.bankAddrCode.split('/')
            let bankArrName = data.bankAddr.split('/')
            if(bankArrCode.length==1 && bankArrName.length==1){
              this.bankArea = [{}]
              this.bankArea[0].code = bankArrCode[0]
              this.bankArea[0].name = bankArrName[0]
            }
            if(bankArrCode.length==2 && bankArrName.length==2){
              this.bankArea = [{},{}]
              this.bankArea[0].code = bankArrCode[0]
              this.bankArea[1].code = bankArrCode[1]
              this.bankArea[0].name = bankArrName[0]
              this.bankArea[1].name = bankArrName[1]
            }            
            
            let subBank = {}
            subBank.bankName = data.bankName
            subBank.bankCode = data.bankCode
            this.tempSubBankName = data.bankName;
            this.tempSubBankCode = data.bankCode;
            this.subBank = subBank
            this.subBankName = this.subBank.bankName
            this.bankNo = data.accountNumber
          }
        }
      })
    },
    toApply(){
      this.stepIndex = 1;
    },
    lastStep(){
      this.stepIndex--
    },
    nextStep(){
      if (!this.checkInput(this.stepIndex)) {
        return
      }
      this.stepIndex++
      //滚动条置顶
      document.documentElement.scrollTop = document.body.scrollTop = 0;
    },
    // 上传图片
    // 组件方法 获取 流
    async onRead(file) {
      const isLt2M = file.file.size / 1024 / 1024 < 2
      if (!isLt2M) {
        Toast('图片大小不能超过2MB!')
        return false;
      }
      this.uploadToast = Toast.loading({
        duration: 0,       // 持续展示 toast
        forbidClick: true, // 禁用背景点击
        loadingType: 'spinner',
        message: '图片上传中，请稍候...'
      });
      this.files.name = file.file.name; // 获取文件名
      this.files.type = file.file.type; // 获取类型
      this.picValue = file.file; // 文件流
      this.imgPreview(this.picValue);
    },
    // 处理图片
    imgPreview(file) {
      let self = this;
      // eslint-disable-next-line no-unused-vars
      let Orientation;
      //去获取拍照时的信息，解决拍出来的照片旋转问题
      Exif.getData(file, function() {
        Orientation = Exif.getTag(this, "Orientation");
      });
      // 看支持不支持FileReader
      if (!file || !window.FileReader) return;
      if (/^image/.test(file.type)) {
        // 创建一个reader
        let reader = new FileReader();
        // 将图片2将转成 base64 格式
        reader.readAsDataURL(file);
        // 读取成功后的回调
        reader.onloadend = function() {
          let result = this.result;
          let img = new Image();
          img.src = result;
          
          self.headerImage = this.result;
          self.postImg();
          //判断图片是否小于200K,是就直接上传，反之压缩图片
          // if (this.result.length <= 200 * 1024) {
          //   self.headerImage = this.result;
          //   self.postImg();
          // } else {
          //   img.onload = function() {
          //     let data = self.compress(img, Orientation);
          //     self.headerImage = data;
          //     self.postImg();
          //   };
          // }
        };
      }
    },
    // 压缩图片
    compress(img, Orientation) {
      let canvas = document.createElement("canvas");
      let ctx = canvas.getContext("2d");
      //瓦片canvas
      let tCanvas = document.createElement("canvas");
      let tctx = tCanvas.getContext("2d");
      // let initSize = img.src.length;
      let width = img.width;
      let height = img.height;
      //如果图片大于四百万像素，计算压缩比并将大小压至400万以下
      let ratio;
      if ((ratio = (width * height) / 4000000) > 1) {
        // console.log("大于400万像素");
        ratio = Math.sqrt(ratio);
        width /= ratio;
        height /= ratio;
      } else {
        ratio = 1;
      }
      canvas.width = width;
      canvas.height = height;
      //    铺底色
      ctx.fillStyle = "#fff";
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      //如果图片像素大于100万则使用瓦片绘制
      let count;
      if ((count = (width * height) / 1000000) > 1) {
        // console.log("超过100W像素");
        count = ~~(Math.sqrt(count) + 1); //计算要分成多少块瓦片
        //      计算每块瓦片的宽和高
        let nw = ~~(width / count);
        let nh = ~~(height / count);
        tCanvas.width = nw;
        tCanvas.height = nh;
        for (let i = 0; i < count; i++) {
          for (let j = 0; j < count; j++) {
            tctx.drawImage(
              img,
              i * nw * ratio,
              j * nh * ratio,
              nw * ratio,
              nh * ratio,
              0,
              0,
              nw,
              nh
            );
            ctx.drawImage(tCanvas, i * nw, j * nh, nw, nh);
          }
        }
      } else {
        ctx.drawImage(img, 0, 0, width, height);
      }
      //修复ios上传图片的时候 被旋转的问题
      if (Orientation != "" && Orientation != 1) {
        switch (Orientation) {
          case 6: //需要顺时针（向左）90度旋转
            this.rotateImg(img, "left", canvas);
            break;
          case 8: //需要逆时针（向右）90度旋转
            this.rotateImg(img, "right", canvas);
            break;
          case 3: //需要180度旋转
            this.rotateImg(img, "right", canvas); //转两次
            this.rotateImg(img, "right", canvas);
            break;
        }
      }
      //进行最小压缩
      let ndata = canvas.toDataURL("image/jpeg", 1);
      tCanvas.width = tCanvas.height = canvas.width = canvas.height = 0;
      return ndata;
    },
    // 旋转图片
    rotateImg(img, direction, canvas) {
      //最小与最大旋转方向，图片旋转4次后回到原方向
      const min_step = 0;
      const max_step = 3;
      if (img == null) return;
      //img的高度和宽度不能在img元素隐藏后获取，否则会出错
      let height = img.height;
      let width = img.width;
      let step = 2;
      if (step == null) {
        step = min_step;
      }
      if (direction == "right") {
        step++;
        //旋转到原位置，即超过最大值
        step > max_step && (step = min_step);
      } else {
        step--;
        step < min_step && (step = max_step);
      }
      //旋转角度以弧度值为参数
      let degree = (step * 90 * Math.PI) / 180;
      let ctx = canvas.getContext("2d");
      switch (step) {
        case 0:
          canvas.width = width;
          canvas.height = height;
          ctx.drawImage(img, 0, 0);
          break;
        case 1:
          canvas.width = height;
          canvas.height = width;
          ctx.rotate(degree);
          ctx.drawImage(img, 0, -height);
          break;
        case 2:
          canvas.width = width;
          canvas.height = height;
          ctx.rotate(degree);
          ctx.drawImage(img, -width, -height);
          break;
        case 3:
          canvas.width = height;
          canvas.height = width;
          ctx.rotate(degree);
          ctx.drawImage(img, -width, 0);
          break;
      }
    },
    //将base64转换为文件
    dataURLtoFile(dataurl) {
      var arr = dataurl.split(","),
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], this.files.name, {
        type: this.files.type
      });
    },
    //这里写接口
    async postImg() {
      let type = 1 //营业执照type = 3 ,身份证正面type = 1  反面type = 2
      switch (this.uploadFlag) {
        case 'businessLicense':
          type = 3
          this.businessLongTime = false
          this.businessInfo = Object.assign({}, this.businessInfo, { bussLicenseNum: '', bussBeginDate: '' })
          this.merchantName = ''
          this.companyAddress = ''
          break;
        case 'idCardFront':
          type = 1
          this.legalPerson = Object.assign({}, this.legalPerson, { idCardNumber: '', idCardName: '',idCardAddress : '' })
          break;
        case 'idCardBehind':
          type = 2
          this.legalPerson = Object.assign({}, this.legalPerson, { validityBegin: '', validityEnd: ''})
          break;
        default: type = 1
      }
      let file = this.dataURLtoFile(this.headerImage);
      //由于上传经过Nginx路由会报错，所以上传接口强制转成首页接口所返回的env的环境的接口
      // const aurl = "https://" + this.env + ".kdzwy.com/ommall/wechat/serviceprovider/uploadImg";
      const aurl = location.host === 'www.kdzwy.com' ? ("https://www.kdzwy.com/ommall/wechat/serviceprovider/uploadImg2?type=" + type) : ("https://mock.kdzwy.com/ommall/wechat/serviceprovider/uploadImg2?type=" + type);
      let formData = new FormData();
      formData.append("file", file);
      try {
        const instance = axios.create({
        withCredentials: true
      });
      instance.defaults.headers.post['Content-Type'] = 'multipart/form-data;charset=UTF-8';
      instance
        .post(
          aurl,
          formData
        )
        .then(res => {
          if (res.data.code == 200) {
            let imageMap = res.data.data.imageMap;
            switch (this.uploadFlag) {
              case 'businessLicense':
                this.businessLicense = decodeURIComponent(res.data.data.imgUrl)
                this.businessMediaId = decodeURIComponent(res.data.data.mediaId || '')
                
                if(imageMap.date){
                  if(imageMap.date == '长期'){
                    this.businessLongTime = true
                  }else{
                    this.businessLongTime = true
                    let datenum = imageMap.date.replace('年','-').replace('月','-').replace('日','')
                    this.businessInfo = Object.assign({}, this.businessInfo, { bussBeginDate: datenum })
                  }
                }
                if(imageMap.code){
                  this.businessInfo = Object.assign({}, this.businessInfo, { bussLicenseNum: imageMap.code })
                }
                if(imageMap.name){
                  this.merchantName = imageMap.name
                }
                if(imageMap.address){
                  this.companyAddress = imageMap.address
                }
                break;
              case 'idCardFront':
                this.idCardFront = decodeURIComponent(res.data.data.imgUrl)
                this.idCardFrontMediaId = decodeURIComponent(res.data.data.mediaId || '')
                if(imageMap.code){
                  this.legalPerson = Object.assign({}, this.legalPerson, { idCardNumber: imageMap.code })
                }
                if(imageMap.name){
                  this.legalPerson = Object.assign({}, this.legalPerson, { idCardName: imageMap.name })
                }
                if (imageMap.idCardAddress) {
                  this.legalPerson = Object.assign({}, this.legalPerson, { idCardAddress: imageMap.idCardAddress })
                }
                break;
              case 'idCardBehind':
                this.idCardBehind = decodeURIComponent(res.data.data.imgUrl)
                this.idCardBehindMediaId = decodeURIComponent(res.data.data.mediaId || '')
                if(imageMap.startDate && imageMap.startDate.length == 8){
                  let begindate = imageMap.startDate.slice(0,4) + '-' + imageMap.startDate.slice(4,6) + '-' + imageMap.startDate.slice(6,8)
                  this.legalPerson = Object.assign({}, this.legalPerson, { validityBegin: begindate })
                }
                if(imageMap.lastDate && imageMap.lastDate.length == 8){
                  let endate = imageMap.lastDate.slice(0,4) + '-' + imageMap.lastDate.slice(4,6) + '-' + imageMap.lastDate.slice(6,8)
                  this.legalPerson = Object.assign({}, this.legalPerson, { validityEnd: endate })
                }
                break;
            }
            Toast.success('上传成功');
            this.uploadToast.duration = 2;
          } else {
            Toast(res.data.msg);
          }
        })
        .catch(error => {
          console.log(error, "error");
          Toast.clear();
        });
      } catch (e) {
        console.log(e);
      }
    },
    preImgClick(item){
      const imgList = [];
      imgList.push(item);
      this.imagePreview = ImagePreview({
        images: imgList
      });
    },
    deleteImg(type){
      switch (type) {
        case 'businessLicense':
          this.businessLicense = ''
          this.businessMediaId = ''
          break;
        case 'idCardFront':
          this.idCardFront = ''
          this.idCardFrontMediaId = ''
          break;
        case 'idCardBehind':
          this.idCardBehind = ''
          this.idCardBehindMediaId = ''
          
          break;
      }
    },
    toApplyRate(){
      this.$router.push('applyRate')
    },
    confirmBussBeginDate(date){
      this.selectBusinessTimeBegin = false
      this.businessInfo.bussBeginDate = date.getFullYear() + '-' + ((date.getMonth() + 1) < 10 ? '0' + (date.getMonth()+1) : date.getMonth() +1) + '-' + (date.getDate() < 10 ? '0' + date.getDate() : date.getDate())
    },
    confirmBussEndDate(date){
      this.selectBusinessTimeEnd = false
      this.businessInfo.bussEndDate = date.getFullYear() + '-' + ((date.getMonth() + 1) < 10 ? '0' + (date.getMonth()+1) : date.getMonth() +1) + '-' + (date.getDate() < 10 ? '0' + date.getDate() : date.getDate())
    },
    confirmBeginDate(date){
      this.selectBeginDate = false
      this.legalPerson.validityBegin = date.getFullYear() + '-' + ((date.getMonth() + 1) < 10 ? '0' + (date.getMonth()+1) : date.getMonth() +1) + '-' + (date.getDate() < 10 ? '0' + date.getDate() : date.getDate())
    },
    confirmEndDate(date){
      this.selectEndDate = false
      this.legalPerson.validityEnd = date.getFullYear() + '-' + ((date.getMonth() + 1) < 10 ? '0' + (date.getMonth()+1) : date.getMonth() +1) + '-' + (date.getDate() < 10 ? '0' + date.getDate() : date.getDate())
    },
    confirmBank(bank){
      this.baseBank = bank
      this.selectBanks = false
      this.getSubBank()
    },
    confirmArea(area){
      if(this.bankArea.length > 0 && this.bankArea[0].name != area[0].name){
         this.subBank = {}
         this.subBankName = ''
      }
      this.selectBanksArea = false
      this.bankArea = area
    },
    getBaseBanks(){
      this.$http.get('/ommall/wechat/serviceprovider/getbasebank').then(res=>{
        if (res.data.code == 200) {
          this.banks = res.data.data
          this.banks.forEach(bank => {
            bank.text = bank.bankName
          });
        }
      })
    },
    getSubBank(){
      let self = this
      const CancelToken = this.$http.CancelToken;
      let bankCode = this.baseBank.bankNo
      this.$http.get('/ommall/wechat/serviceprovider/findbankbranch?parentCode='+bankCode+'&bankName='+this.subBankName,{
        cancelToken: new CancelToken(function executor(c) {
          self.cancel = c;
        })
      }).then(res =>{
        if (res.data.code == 200) {
          this.subBanks = res.data.data
        }
      })
      setTimeout(() => {
        self.cancel()
      }, 500);
    },
    subBankFocus () {
      this.subBankEdit = true;
    },
    selectSubBank(bank){
      this.subBank = bank
      this.tempSubBankName = bank.bankName
      this.tempSubBankCode = bank.bankCode
      this.subBankName = bank.bankName
    },
    endEdit(){
      setTimeout(() => {
        this.subBankEdit=false
      },500)
    },
    checkInput(step){
      let isIdCard = new RegExp(/^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/)
      let isPhone = new RegExp(/^[1][3-9][0-9]{9}$/)
      let isEmail = new RegExp('^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(\\.[a-zA-Z0-9_-])+')
      if (step == 1) {
        if (!this.contactorInfo.contact) {
          Toast("请输入超级管理员姓名");
          return false
        }
        if (!this.contactorInfo.contactPhone || !isPhone.test(this.contactorInfo.contactPhone)) {
          Toast("请输入正确的手机号码");
          return false
        }
        if (!this.contactorInfo.contactIdNumber || !isIdCard.test(this.contactorInfo.contactIdNumber)) {
          Toast("请输入正确的身份证号码");
          return false
        }
        if (!this.contactorInfo.contactEmail || !isEmail.test(this.contactorInfo.contactEmail)) {
          Toast("请输入正确的邮箱");
          return false
        }
        if (!this.manageInfo.mchShortname) {
          Toast("请输入商户简称");
          return false
        }
        if (!this.manageInfo.publicName) {
          Toast("请输入公众号名称");
          return false
        }
        if (!this.manageInfo.productDesc) {
          Toast("请输入服务概述");
          return false
        }
        if (!this.manageInfo.productDesc) {
          Toast("请输入服务概述");
          return false
        }
        if (!this.manageInfo.servicePhone) {
          Toast("请输入服务电话");
          return false
        }
      } else if (step == 2) {
        if (!this.businessLicense) {
          Toast("请上传营业执照");
          return false
        }
        if (!this.businessInfo.bussBeginDate || (!this.businessInfo.bussEndDate && !this.businessLongTime)) {
          Toast("请输入选择营业期限");
          return false
        }
        // let isAf = moment(this.businessInfo.bussEndDate).isAfter(this.businessInfo.bussBeginDate);
        // if (!isAf && !moment(this.businessInfo.bussEndDate).isSame(this.businessInfo.bussBeginDate)) {
        //   Toast("营业期限结束期间应大于开始期间，请重新选择");
        //   return;
        // }
        if (!this.businessInfo.bussLicenseNum) {
          Toast("请输入营业执照注册号");
          return false
        }
        if (!this.businessInfo.businessScope) {
          Toast("请输入经营范围");
          return false
        }
        if (!this.merchantName) {
          Toast("请输入商户名称");
          return false
        }
        if (!this.companyAddress) {
          Toast("请输入注册地址");
          return false
        }
        if (!this.idCardFront) {
          Toast("请上传身份证正面照片");
          return false
        }
        if (!this.idCardBehind) {
          Toast("请上传身份证背面照片");
          return false
        }
        if (!this.legalPerson.idCardNumber || !isIdCard.test(this.legalPerson.idCardNumber)) {
          Toast("请输入正确的身份证号码");
          return false
        }
        if (!this.legalPerson.idCardName) {
          Toast("请输入身份证姓名");
          return false
        }
        if (this.legalPerson.idCardName !== this.contactorInfo.contact) {
          Toast("您第一步填写的超级管理员姓名与法人资料不一致,请返回修改");
          return false
        }
        if (this.contactorInfo.contactIdNumber !== this.legalPerson.idCardNumber) {
          Toast("您第一步填写的超级管理员身份证号码与法人资料不一致,请返回修改");
          return false
        }
        if (!this.legalPerson.validityBegin || (!this.legalPerson.validityEnd && !this.idCardLongTime)) {
          Toast("请选择证件有效期")
          return false
        }
        if (!this.legalPerson.idCardAddress) {
          Toast("请输入身份证地址");
          return false
        }
        // let isVAf = moment(this.legalPerson.validityEnd).isAfter(this.legalPerson.validityBegin);
        // if (!isVAf && !moment(this.legalPerson.validityEnd).isSame(this.legalPerson.validityBegin)) {
        //   Toast("证件有效期结束期间应大于开始期间，请重新选择");
        //   return;
        // }
      } else if (step == 3) {
        if (this.baseBank == {}) {
          Toast("请选择基本户开户行");
          return false
        }
        if (!this.subBankArea) {
          Toast("请选择开户支行的省市");
          return false
        }
        if (this.baseBank.bankName === '其他银行' && !this.subBank.bankName) {
          Toast("请选择正确的开户支行");
          return false
        }
        if (this.baseBank.bankName === '其他银行' && (!this.subBank.bankCode || this.subBank.bankCode == 'undefined' || (this.tempSubBankCode == this.subBank.bankCode && this.tempSubBankName != this.subBank.bankName))) {
          Toast("开户支行名称必须从下拉列表中选取，如果没有对应支行，可以选择上级分行名称");
          return false
        }
        if (!this.bankNo) {
          Toast("请输入基本户银行账号");
          return false
        }
      }
      return true
    },
    submitConfirm(){
      if (!this.checkInput(3)) {
        return
      }
      if(this.submiting){
         return
      }
      let eid = ''
      if (!this.eid) {
        eid = window.sessionStorage.getItem('eid')
      } else {
        eid = this.eid
      }
      let accountName = this.companyName ? this.companyName : this.$store.state.acctCompanyInfo.name
      let param = {
        'contact': this.contactorInfo.contact,
        'contactPhone': this.contactorInfo.contactPhone,
        'contactIdNumber': this.contactorInfo.contactIdNumber,
        'contactEmail': this.contactorInfo.contactEmail,
        'mchShortname': this.manageInfo.mchShortname,
        'manageType': this.manageInfo.manageType,
        'publicName': this.manageInfo.publicName,
        'productDesc': this.manageInfo.productDesc,
        'servicePhone': this.manageInfo.servicePhone,
        'businessTime': [this.businessInfo.bussBeginDate, this.businessInfo.bussEndDate],
        'businessScope': this.businessInfo.businessScope,
        'bussLicenseCopyUrl': this.businessLicense,
        'bussLicenseCopy': this.businessMediaId,
        'bussLicenseNum': this.businessInfo.bussLicenseNum,
        'merchantName': this.merchantName,
        'companyAddress': this.companyAddress,
        'idCardCopyUrl': this.idCardFront,
        'idCardCopy': this.idCardFrontMediaId,
        'idCardNationalUrl': this.idCardBehind,
        'idCardNational': this.idCardBehindMediaId,
        'idCardNumber': this.legalPerson.idCardNumber,
        'idCardName': this.legalPerson.idCardName,
        'idCardValidTime': [this.legalPerson.validityBegin, this.legalPerson.validityEnd],
        'idCardAddress': this.legalPerson.idCardAddress,
        'accountName': accountName,
        'accountBank': this.baseBank.bankName,
        'accountBankCode': this.baseBank.bankNo,
        'bankAddrCode': (this.bankArea[0] ? this.bankArea[0].code : '') + (this.bankArea[1] ? '/' + this.bankArea[1].code : ''),
        'bankAddr': (this.bankArea[0] ? this.bankArea[0].name : '') + (this.bankArea[1] ? '/' + this.bankArea[1].name : '') ,
        'bankName': this.subBank.bankName,
        'bankCode': this.subBank.bankCode,
        'accountNumber': this.bankNo,
        'eid': eid
      }
      if (this.businessLongTime) {
        param.businessTime = [this.businessInfo.bussBeginDate, '长期']
      }
      if (this.idCardLongTime) {
        param.idCardLongTime = [this.legalPerson.validityBegin, '长期']
      }
      if (this.applyId) {
        param.id = this.applyId
      }
      this.submiting = true
      this.$http.post('/ommall//wechat/serviceprovider/applymich', param).then(response =>{
        this.submiting = false
        if (response.data.code == 200) {
          this.applySubmit = true
        }else{
          this.$toast(response.data.msg)
        }
      })
      .catch(error => {
        Toast(error);
      });
    }
  }
}
</script>

<style lang="stylus">
  .apply-collection {
    background-color: #F9FBFC;
    height:100%;
  }
  .apply-bg {
    position: relative;
    padding-bottom: 0.1rem;
    background-color: #F9FBFC;
    width:100%;
    overflow-y: auto;
    img {
      width: 100%;
    }
  }
  .apply-submit {
    position: absolute;
    background: white;
    height:100%;
    width: 100%;
    // margin-top: 1.04rem;
  }
  .footer {
    position: fixed;
    display: flex;
    bottom: 0;
    width: 100%;
    height:100%
    height:0.44rem;
    line-height: 0.44rem;
    background: white;
    div {
      text-align: center
      fonts-size: 0.15rem;
    }
  }

  .apply-header {
    width:100%;
    height:1.7rem;
    background:linear-gradient(180deg,rgba(255,135,79,1) 0%,rgba(255,91,50,1) 100%);
    .steps {
      height:1.2rem;
      width: 100%;
      display: flex;
      .step-index {
        height:0.48rem;
        width:0.48rem;
        font-size:0.23rem;
        line-height:0.48rem;
        text-align:center;
        margin: auto;
        margin-top: 0.22rem;
        border-radius: 0.24rem;
      }
      .step-title {
        font-size:0.15rem;
        width:100%;
        text-align:center;
        line-height:0.3rem;
      }
      .step-line {
        position: absolute;
        height: 1px;
        background: #FFB99F;
        width: 2.9rem;
        z-index : 0;
        margin-top: 0.46rem;
        margin-left: 0.4rem;
      }
      .step {
        z-index: 100;
      }
    }
  }
  .businessLongTime {
    position: relative;
    float: right;
  }
  .step-content {
    position: relative;
    top: -0.5rem;
    margin: 0 0.12rem;
  }

  .step-one, .step-two {
    width:100%;
  }

  .step-row {
    width:100%;
    background:rgba(255,255,255,1);
    box-shadow:0px 2px 16px 0px rgba(0,0,0,0.1);
    border-radius:4px;
  }
  .row-title {
    width:100%;
    text-align:center;
    height: 0.5rem;
    line-height: 0.5rem;
    span {
      font-size:0.16rem;
      font-weight: 500;
      color: #FF5C32;
      margin: 0 0.05rem;
    }
  }
  .row-content {
    padding: 0 0.12rem;
    margin-bottom :0.25rem;
  }

  .input-explain {
    margin-top:0.08rem;
    color:#B4BEC7;
  }

  .input-title {
    color: #3B4C5E;
    font-size: 0.15rem;
  }

  .input-content {
    input {
      height:0.32rem;
      border:1px solid #B4BEC7;
      width: 3rem;
      padding:0 0.1rem;
      caret-color:#FF5C32;
      color: #1A2633;
      margin-top:0.05rem;
    }
    textarea {
      width: 3rem;
      border:1px solid #B4BEC7;
      padding:0.1rem 0.1rem;
      caret-color:#FF5C32;
      color: #1A2633;
      margin-top:0.05rem;
    }
  }

  .upload-row {
    margin-top: 0.1rem;
  }
  .business-license {
    height:0.85rem;
    width:0.85rem;
  }
  .pluss {
    width: 0.85rem;
    height: 0.85rem;
    border: 1px solid #F0F2F2;
    // line-height: 0.85rem;
    text-align: center;
    color: #B4BEC7;
    background: #F9FBFC;
    span {
      display: block;
    }
  }
  .pluss-idcard {
    width: 1.5rem;
    height: 1.1rem;
    border: 1px solid #F0F2F2;
    // line-height: 0.85rem;
    text-align: center;
    color: #B4BEC7;
    background: #F9FBFC;
    span {
      display: block;
    }
  }

  .uploadImgRow {
    text-align: center;
    padding: 0.08rem 0;
    padding-bottom: 0.2rem;
  }

  .uploadImgCol {
    font-size 0
    position relative
    .imgDeleteBtn, .imgDeleteBtn-idcard{
      font-size 0.2rem
      position: absolute;
      bottom: 0;
      right: 0.23rem;
      padding 0.02rem
      background rgba(0,0,0,0.1);
      color #ffffff
      line-height: 0.2;
    }
    .imgDeleteBtn-idcard {
      right: 0.14rem !important;
    }
  }

  .uploadImg {
    height:0.85rem;
    width:0.85rem !important;
  }

  .uploadImg-idcard {
    width: 1.5rem !important;
    height: 1.1rem;
  }

  .dateRange-row {
    input {
      height:0.32rem;
      border:1px solid #B4BEC7;
      width: 1.2rem;
      padding:0 0.1rem;
      caret-color:#FF5C32;
      color: #1A2633;
      margin-top:0.05rem;
    }
  }

  input:disabled {
    background: #ffffff;
    color: #1A2633;
  }

  .basic-banks {
    height: 0.32rem;
    line-height: 0.32rem;
    border: 1px solid #b4bec7;
    padding: 0 0.1rem;
    width: 3rem;
    caret-color: #ff5c32;
    color: #1a2633;
    margin-top: 0.05rem;
  }
  .corner {
    float: right;
    width: 0px;
    height: 0px;
    border: 4px solid #b4bec7;
    border-bottom-color: transparent;
    border-left-color: transparent;
    border-right-color: transparent;
    position: relative;
    right: 0.15rem;
    top: -0.18rem;
  }

  .area-province, .area-city {
    height: 0.32rem;
    line-height: 0.32rem;
    border: 1px solid #b4bec7;
    padding: 0 0.1rem;
    caret-color: #ff5c32;
    color: #1a2633;
    margin-top: 0.05rem;
    width: 3rem;
  }

  .subbank-list {
    max-height: 1.6rem;
    overflow: auto;
    width: 3rem;
    padding:0 0.1rem;
    border-left: 1px solid #b4bec7;
    border-right: 1px solid #b4bec7;
    border-bottom: 1px solid #b4bec7;
  }

  .sub-bank {
    line-height: 0.32rem;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    border-bottom: 1px solid #b4bec7;
  }

  .icon-light {
    background:linear-gradient(180deg,rgba(255,255,255,1) 0%,rgba(255,235,227,1) 81%,rgba(255,231,222,1) 100%);
    color:#FF5D33;
  }

  .icon-gray {
    background: #FFB99F;
    color: #FF824C;
  }

  .color-confirm {
    background: #FF5E35;
  }
  .color-gray {
    color: #FF9B78;
  }

  .mt12 {
    margin-top: 0.12rem;
  }

  .red-color{
    color: #FF5C32;
  }
  .white-color {
    color: white !important;
  }

  .submit-img {
    margin-top: 1.04rem;
    text-align:center;
    img {
      width:1.36rem;
    }
  }
  .rate-row {
    position: absolute;
    bottom: 0.56rem;
    width: 100%;
  }
  textarea:disabled {
    background: white;
  }
</style>

<style lang="stylus">
  .apply-collection .van-checkbox__icon {
    font-size: 0.16rem;
  }
</style>
